import { CurrentUser } from 'Roblox';
import { localStorageService } from 'core-roblox-utilities';

const lsKey = CurrentUser?.userId ? `gameSort_${CurrentUser.userId}` : 'gameSort_guest';
const storeSortData = (gameSortData, gameSortContext) => {
  const { sorts: sortData, timeFilters, pageContext } = gameSortData;
  const currentData = new Date();
  const dateStoredTime = currentData.getTime();

  const currentSortValue = localStorageService.getLocalStorage(lsKey) || {};
  const lsValue = {};
  sortData.forEach((sort, index) => {
    const {
      token,
      displayName,
      name,
      gameSetTargetId,
      tokenExpiryInSeconds,
      contextCountryRegionId,
      timeOptionsAvailable
    } = sort;
    const sortPosition = index;
    lsValue[name] = {
      name,
      displayName,
      token,
      gameSetTargetId,
      dateStoredTime,
      tokenExpiryInSeconds,
      gameSortContext,
      sortPosition,
      pageContext,
      contextCountryRegionId,
      timeOptionsAvailable,
      timeFilters
    };
  });

  const updatedSortValue = Object.assign(currentSortValue, lsValue);
  localStorageService.setLocalStorage(lsKey, updatedSortValue);
};

const getSortValueFromStorage = sortName => {
  const sortFromLocalStorage = localStorageService.getLocalStorage(lsKey);
  if (sortFromLocalStorage) {
    return sortFromLocalStorage[sortName];
  }
  return null;
};

const isSortTokenExpired = sort => {
  const currentDateTime = new Date().getTime();
  const { dateStoredTime, tokenExpiryInSeconds } = sort;
  const tokenExpiryInMS = tokenExpiryInSeconds * 1000;
  return dateStoredTime + tokenExpiryInMS < currentDateTime;
};

const getExpirationMS = sortData => {
  if (sortData?.length > 0) {
    return sortData[0].tokenExpiryInSeconds * 1000;
  }
  return 3600000;
};
export { lsKey, storeSortData, getSortValueFromStorage, isSortTokenExpired, getExpirationMS };
